import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDE, LazyEN, LazyFR, LazyHU, LazyNL, LazyPL, LazyRO, LazyFlag, LazyIconAddUser, LazyIconArchive, LazyIconArrowBack, LazyIconArrowLeft, LazyIconArrowNext, LazyIconArrowPrev, LazyIconArrowRight, LazyIconArrowTopbar, LazyIconBack, LazyIconBell, LazyIconBinoculars, LazyIconBold, LazyIconCalendar, LazyIconCaretLeft, LazyIconCaretRight, LazyIconCelebrate, LazyIconCertificate, LazyIconChange, LazyIconCheck, LazyIconCheckCircle, LazyIconCheckCircleTransparent, LazyIconCheckmark, LazyIconClipboard, LazyIconClock, LazyIconClose, LazyIconClose2, LazyIconCloud, LazyIconCompany, LazyIconCopy, LazyIconCountry, LazyIconCrown, LazyIconCsv, LazyIconDashboard, LazyIconDeactivateUser, LazyIconDelete, LazyIconDocumentation, LazyIconDots, LazyIconDownload, LazyIconDownload2, LazyIconDownload3, LazyIconEdit, LazyIconError, LazyIconExcel, LazyIconExclamation, LazyIconExport, LazyIconExternalLink, LazyIconEye, LazyIconFileDocx, LazyIconFilePdf, LazyIconFilePpt, LazyIconFileVideo, LazyIconFileZip, LazyIconFilledCircle, LazyIconFilter, LazyIconFirstPrev, LazyIconFlag, LazyIconFrontend, LazyIconGauge, LazyIconGlobe, LazyIconGroup, LazyIconGroupSingle, LazyIconGroups, LazyIconHeading, LazyIconHeadphone, LazyIconHeart, LazyIconHome, LazyIconHourglass, LazyIconId, LazyIconInfo, LazyIconItalic, LazyIconLastNext, LazyIconLibrary, LazyIconList, LazyIconListOrdered, LazyIconLocation, LazyIconLock, LazyIconLockUnlocked, LazyIconLogo, LazyIconLogout, LazyIconMagnifier, LazyIconMail, LazyIconMail2, LazyIconMailSolid, LazyIconMailer, LazyIconNavbarArrow, LazyIconNotAvailable, LazyIconOptions, LazyIconOverdue, LazyIconPdf, LazyIconPhone, LazyIconPlay, LazyIconPlus, LazyIconQuestionCircle, LazyIconReload, LazyIconSave, LazyIconSettings, LazyIconSettings2, LazyIconSingleMember, LazyIconSort, LazyIconStatus, LazyIconStudy, LazyIconTeamArrow, LazyIconTeammember, LazyIconTechToProtectLogo, LazyIconTheme, LazyIconTodo, LazyIconTopic, LazyIconTraining, LazyIconTrainings, LazyIconTrash, LazyIconUnderline, LazyIconUpload, LazyIconUser, LazyIconVideoPlayer, LazyIconX, LazyIconXCircle, LazyImgAttention, LazyImgElearning, LazyImgElearningBook, LazyImgEntraId, LazyIconDocument, LazyLogoMediaForWork } from '#components'
const lazyGlobalComponents = [
  ["DE", LazyDE],
["EN", LazyEN],
["FR", LazyFR],
["HU", LazyHU],
["NL", LazyNL],
["PL", LazyPL],
["RO", LazyRO],
["Flag", LazyFlag],
["IconAddUser", LazyIconAddUser],
["IconArchive", LazyIconArchive],
["IconArrowBack", LazyIconArrowBack],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowNext", LazyIconArrowNext],
["IconArrowPrev", LazyIconArrowPrev],
["IconArrowRight", LazyIconArrowRight],
["IconArrowTopbar", LazyIconArrowTopbar],
["IconBack", LazyIconBack],
["IconBell", LazyIconBell],
["IconBinoculars", LazyIconBinoculars],
["IconBold", LazyIconBold],
["IconCalendar", LazyIconCalendar],
["IconCaretLeft", LazyIconCaretLeft],
["IconCaretRight", LazyIconCaretRight],
["IconCelebrate", LazyIconCelebrate],
["IconCertificate", LazyIconCertificate],
["IconChange", LazyIconChange],
["IconCheck", LazyIconCheck],
["IconCheckCircle", LazyIconCheckCircle],
["IconCheckCircleTransparent", LazyIconCheckCircleTransparent],
["IconCheckmark", LazyIconCheckmark],
["IconClipboard", LazyIconClipboard],
["IconClock", LazyIconClock],
["IconClose", LazyIconClose],
["IconClose2", LazyIconClose2],
["IconCloud", LazyIconCloud],
["IconCompany", LazyIconCompany],
["IconCopy", LazyIconCopy],
["IconCountry", LazyIconCountry],
["IconCrown", LazyIconCrown],
["IconCsv", LazyIconCsv],
["IconDashboard", LazyIconDashboard],
["IconDeactivateUser", LazyIconDeactivateUser],
["IconDelete", LazyIconDelete],
["IconDocumentation", LazyIconDocumentation],
["IconDots", LazyIconDots],
["IconDownload", LazyIconDownload],
["IconDownload2", LazyIconDownload2],
["IconDownload3", LazyIconDownload3],
["IconEdit", LazyIconEdit],
["IconError", LazyIconError],
["IconExcel", LazyIconExcel],
["IconExclamation", LazyIconExclamation],
["IconExport", LazyIconExport],
["IconExternalLink", LazyIconExternalLink],
["IconEye", LazyIconEye],
["IconFileDocx", LazyIconFileDocx],
["IconFilePdf", LazyIconFilePdf],
["IconFilePpt", LazyIconFilePpt],
["IconFileVideo", LazyIconFileVideo],
["IconFileZip", LazyIconFileZip],
["IconFilledCircle", LazyIconFilledCircle],
["IconFilter", LazyIconFilter],
["IconFirstPrev", LazyIconFirstPrev],
["IconFlag", LazyIconFlag],
["IconFrontend", LazyIconFrontend],
["IconGauge", LazyIconGauge],
["IconGlobe", LazyIconGlobe],
["IconGroup", LazyIconGroup],
["IconGroupSingle", LazyIconGroupSingle],
["IconGroups", LazyIconGroups],
["IconHeading", LazyIconHeading],
["IconHeadphone", LazyIconHeadphone],
["IconHeart", LazyIconHeart],
["IconHome", LazyIconHome],
["IconHourglass", LazyIconHourglass],
["IconId", LazyIconId],
["IconInfo", LazyIconInfo],
["IconItalic", LazyIconItalic],
["IconLastNext", LazyIconLastNext],
["IconLibrary", LazyIconLibrary],
["IconList", LazyIconList],
["IconListOrdered", LazyIconListOrdered],
["IconLocation", LazyIconLocation],
["IconLock", LazyIconLock],
["IconLockUnlocked", LazyIconLockUnlocked],
["IconLogo", LazyIconLogo],
["IconLogout", LazyIconLogout],
["IconMagnifier", LazyIconMagnifier],
["IconMail", LazyIconMail],
["IconMail2", LazyIconMail2],
["IconMailSolid", LazyIconMailSolid],
["IconMailer", LazyIconMailer],
["IconNavbarArrow", LazyIconNavbarArrow],
["IconNotAvailable", LazyIconNotAvailable],
["IconOptions", LazyIconOptions],
["IconOverdue", LazyIconOverdue],
["IconPdf", LazyIconPdf],
["IconPhone", LazyIconPhone],
["IconPlay", LazyIconPlay],
["IconPlus", LazyIconPlus],
["IconQuestionCircle", LazyIconQuestionCircle],
["IconReload", LazyIconReload],
["IconSave", LazyIconSave],
["IconSettings", LazyIconSettings],
["IconSettings2", LazyIconSettings2],
["IconSingleMember", LazyIconSingleMember],
["IconSort", LazyIconSort],
["IconStatus", LazyIconStatus],
["IconStudy", LazyIconStudy],
["IconTeamArrow", LazyIconTeamArrow],
["IconTeammember", LazyIconTeammember],
["IconTechToProtectLogo", LazyIconTechToProtectLogo],
["IconTheme", LazyIconTheme],
["IconTodo", LazyIconTodo],
["IconTopic", LazyIconTopic],
["IconTraining", LazyIconTraining],
["IconTrainings", LazyIconTrainings],
["IconTrash", LazyIconTrash],
["IconUnderline", LazyIconUnderline],
["IconUpload", LazyIconUpload],
["IconUser", LazyIconUser],
["IconVideoPlayer", LazyIconVideoPlayer],
["IconX", LazyIconX],
["IconXCircle", LazyIconXCircle],
["ImgAttention", LazyImgAttention],
["ImgElearning", LazyImgElearning],
["ImgElearningBook", LazyImgElearningBook],
["ImgEntraId", LazyImgEntraId],
["IconDocument", LazyIconDocument],
["LogoMediaForWork", LazyLogoMediaForWork],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
